import { Image } from '@/components'
import { URL_ICON, URL_IMG } from '@/constants/ui'
import { getVND } from '@/utils/helpers'
import { Box, Skeleton, Stack, SvgIcon, SvgIconProps, Typography } from '@mui/material'
import CountdownFlashSale from './countdown-flash-sale'

type propsPanelFlashSale = {
  data: Product
  productSelected?: IVariantsProduct | null
  isLoading?: boolean
}

export default function PanelFlashSale({ data, productSelected, isLoading }: propsPanelFlashSale) {
  // Lấy daily_sale từ variant (sản phẩm con) nếu có, nếu không thì lấy từ product cha
  const dailySale = productSelected?.product?.daily_sale || data?.daily_sale

  // // Không hiển thị nếu không có daily_sale hoặc thiếu dữ liệu cần thiết
  if (!dailySale?.end_date) {
    return null
  }
  const regularPrice = productSelected?.product?.price_range?.minimum_price?.regular_price?.value || 0
  const salePrice = dailySale.sale_price || 0
  const saleQty = dailySale.saleable_qty || 0
  const soldQty = dailySale.sold_qty || 0
  const percentSold = saleQty > 0 ? Math.min((soldQty / saleQty) * 100, 100) : 0

  return (
    <Box
      sx={{
        p: 1,
        borderRadius: 2,
        minHeight: '150px',
        background: '#F46A00',
        position: 'relative',
        overflow: 'hidden',
      }}
    >
      <Image
        src={URL_IMG + 'bg-panel-sale.jpg'}
        alt="Panel Flash Sale"
        style={{
          position: 'absolute',
          width: '100%',
          top: 0,
          left: 0,
          height: '100%',
          zIndex: 1,
          objectFit: 'cover',
          borderRadius: 'inherit',
        }}
      />
      {isLoading ? (
        <Skeleton variant="rectangular" height={150} />
      ) : (
        <Stack position={'relative'} zIndex={2}>
          <Stack
            sx={{
              gap: 1,
            }}
          >
            {/* Text Flash Sale */}
            <Stack
              direction="row"
              spacing={1}
              fontSize={{
                xs: '18px',
                sm: '20px',
                md: '22px',
                lg: '24px',
              }}
              alignItems="center"
              justifyContent="space-between"
            >
              <Stack direction="row" alignItems="center" spacing={0.5}>
                <LightningIcon sx={{ fontSize: 'inherit' }} />
                <Typography sx={{ ...textStyle, color: textSecondaryColor }}>{dailySale?.title}</Typography>
              </Stack>
            </Stack>
            {/* Info sale*/}
            <Stack
              spacing={1.5}
              sx={{
                p: 1.5,
                background: '#fff',
                borderRadius: 1,
              }}
            >
              <Stack direction="row" alignItems="end" spacing={2} justifyContent="space-between">
                <Stack spacing={1}>
                  <Typography
                    fontSize={'14px'}
                    lineHeight={1}
                    fontWeight={300}
                    color="#9B9A99"
                    sx={{
                      textDecoration: 'line-through',
                    }}
                  >
                    {getVND(regularPrice)}
                  </Typography>
                  <Typography
                    fontSize={{
                      xs: '24px',
                      sm: '26px',
                      lg: '28px',
                    }}
                    fontWeight={700}
                    color="primary.main"
                    lineHeight={1}
                  >
                    {getVND(salePrice)}
                  </Typography>
                </Stack>
                {/* Countdown */}
                <CountdownFlashSale endDate={dailySale.end_date} />
              </Stack>
              {/* Thanh progress sale */}
              <Stack
                justifyContent="center"
                sx={{
                  height: '24px',
                  width: '100%',
                  backgroundColor: '#FEF0E6',
                  borderRadius: '999px',
                  overflow: 'hidden',
                  position: 'relative',
                }}
              >
                <Box
                  typography={'span'}
                  position={'absolute'}
                  width={`${percentSold}%`}
                  left={0}
                  height={'100%'}
                  bgcolor={'#F46A00'}
                  borderRadius={'inherit'}
                ></Box>
                {percentSold > 10 && (
                  <Image
                    src={URL_ICON + 'ic-hot.svg'}
                    alt="ic-hot"
                    style={{
                      position: 'absolute',
                      left: '4px',
                      top: '50%',
                      transform: 'translateY(-50%)',
                      zIndex: 2,
                      aspectRatio: '1/1',
                    }}
                  />
                )}
                <Typography textAlign={'center'} fontSize={'14px'} position={'relative'} zIndex={1}>
                  Đã bán <Box component="span">{soldQty}</Box>
                  <Box component="span">/{saleQty}</Box>{' '}
                </Typography>
              </Stack>
            </Stack>
          </Stack>
        </Stack>
      )}
    </Box>
  )
}
const LightningIcon = (props: SvgIconProps) => (
  <SvgIcon
    {...props}
    viewBox="0 0 24 47"
    sx={{
      width: 'auto',
      height: '1em',
      filter: `drop-shadow(2px 2px 0px ${shadowColor})`,
      ...props.sx,
    }}
  >
    <path
      d="M19.6758 1.79657L11.5996 14.9557H20.1006L19.6865 15.6989L4.05078 43.778L3.12695 43.4216L7.89258 22.9753H0.625L0.761719 22.3659L4.7041 4.79169L4.77148 4.48798L5.0752 4.41473L19.1338 1.04852L20.3076 0.767273L19.6758 1.79657Z"
      fill={textSecondaryColor}
      stroke={strokeColor}
      strokeWidth="1"
    />
  </SvgIcon>
)
const strokeColor = '#F89B54'
const shadowColor = '#AD4B00'
const textPrimaryColor = '#FFFFFF'
const textSecondaryColor = '#FBFF00'

const textStyle = {
  fontWeight: 900,
  lineHeight: 1,
  fontSize: 'inherit',
  // WebkitTextStroke: `1px ${strokeColor}`,
  filter: `drop-shadow(2px 2px 0px ${shadowColor})`,
  letterSpacing: '-0.02em',
  textTransform: 'uppercase',
}
